import React, { useCallback, useEffect, useState } from 'react';
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { getRepaymentSetupLink, setBookloanDetails, setBookloanLoading } from '../redux/features/oxygen/oxygenRetailSlice';
import {useNavigate } from 'react-router-dom';
import { getPrecustomerDetails, updateCustomerOnboardingStat } from '../services/PrequalificationService';
import { updatePrecustomer } from '../redux/features/precustomers/PrecustomerSlice';
import useCustomAlert from '../components/Alert2';
import {confirmOxygenPayment} from "../services/oxygenRetailServices";
import { hideModal, setShowModal } from '../redux/features/oxygen/customModalSlice';
import {bookLoan} from "../services/oxygenRetailServices";

const OxygenPaymentLinks = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const customAlert = useCustomAlert();
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(1);
    const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData);
    const repaymentLink = useSelector((state) => state?.oxygenRetail?.repaymentSetupLink);

    const customerDetails = useCallback(async() =>{
        // Fetch customer details
        const res = await getPrecustomerDetails(
        storePrecustomer?.precustomer?.precustomerId
        );

        if (res?.status === true) {
            dispatch(setBookloanDetails(res?.data));
        }
    }, [dispatch, storePrecustomer?.precustomer?.precustomerId])

    useEffect(() =>{
        dispatch(getRepaymentSetupLink(storePrecustomer.precustomer?.precustomerId));
        customerDetails();
    }, [ dispatch, storePrecustomer.precustomer?.precustomerId, customerDetails]);

    // for oxygen book loan:
    const oxygenBookLoan = async() => {
        dispatch(setBookloanLoading(true));
        const payload = {
            PreCustomerId:storePrecustomer.precustomer?.precustomerId
        }
        
        const res = await bookLoan(payload);

        if(res?.status === true){
            dispatch(setBookloanLoading(false));
            customAlert.showToast("success", `${res?.message}` || "Loan booked successfully");
            dispatch(hideModal());
            navigate("/oxygenLoan-OTP")
        }else{
            dispatch(setBookloanLoading(false));
            customAlert.showToast("error", `${res?.message}` || "Failed to book loan");
        }
    }

    const handleReBookLoan = async() => {
        dispatch(setShowModal({
            status:true,
            title:"Book Loan",
            type:"bookLoan",
            showCloseButton:false,
            data:{oxygenBookLoan},
        }));
    }

    const handleVerifyPayment = async () =>{
        setLoading(true);
        const payload = {
            preCustomerId:Number(storePrecustomer.precustomer?.precustomerId),
        }

        const res = await confirmOxygenPayment(payload);
   
        if(res?.status === true){
            // Make api call to update the onboarding status since device reg is successful
            await updateCustomerOnboardingStat(
            storePrecustomer?.precustomer?.msisdn,
            "KYC_APPROVED"
            );

            dispatch(
                updatePrecustomer({
                    ...storePrecustomer,
                    onboarding_status: "sideload",
                })
            )
            setLoading(false);
            customAlert.showToast("success", `${res?.message}` || "payment verified successfully");
            navigate("/sideload");

        }else{
            setLoading(false);
            customAlert.showToast("error", `${res?.message}` || "Failed to verify payment");
        }
    }

  return (
    <PageWrapper>
        <PageTitle title="Customer's Payment Links"/>
            <>
            {/* <div className="d-flex flex-column flex-md-row align-items-center justify-content-end">
                <button
                    onClick={() => handleReBookLoan ()}
                    className="btn btn-dark text-white"
                >
                    Book Loan
                </button>
            </div> */}
            <div className="card-body p-6">
                <div className="panel panel-primary">
                    <div className="panel-body tabs-menu-body">
                        <div className="tab-content">
                            <div className="tab-pane active" id="tab2">
                                {
                                   step === 1 ? (
                                    <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                                        <div className="py-5">
                                            <h2 className="page-title">Repayment Setup Link</h2>
                                            <h5 className="py-2">Scan the QR Code to set up your payment link or</h5>
                                        </div>
                                        <div className="pb-5">
                                        <a
                                            href={repaymentLink?.data?.repaymentSetupLink || "#"}
                                            className="btn btn-primary"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Pay Now
                                        </a>
                                        </div>
                                    </div>
                                   ):(
                                    <div className="d-flex flex-column flex-md-row align-items-center justify-content-between">
                                        <div className="py-5">
                                            <h2 className="page-title">Initial payment Link</h2>
                                            <h5 className="py-2">Scan the QR Code to make initial payment or</h5>
                                        </div>
                                        <div className="pb-5">
                                            <a
                                                href={ repaymentLink?.data?.splitPaymentLink || "#"}
                                                className="btn btn-primary"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                Pay Now
                                            </a>
                                        </div>
                                    </div>
                                   ) 
                                }
                                <div style={{ maxWidth: 300 }}>
                                    <img
                                        alt="qr code"
                                        style={{ width: "100%" }}
                                        src={
                                            step === 1
                                                ? `data:image/png;base64,${repaymentLink?.data?.repaymentSetupLinkBase64}`
                                                : `data:image/png;base64,${repaymentLink?.data?.splitPaymentLinkBase64}`
                                        }
                                    />
                                </div>

                                {/* Next & Back Button */}
                                <div className="m-6 pt-5" >
                                    <button
                                        onClick={() => setStep(step === 1 ? 2 : 1)}
                                        className="btn btn-info pull-right"
                                    >
                                        {step === 1 ? "NEXT" : "BACK"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mb-5 d-grid gap-2">
                <button
                    onClick={() => handleVerifyPayment()}
                    className="btn btn-primary text-white"
                    disabled={loading}
                >
                    {loading ? "Please wait..." : "Proceed"}
                </button>
            </div>
            </>
    </PageWrapper>
  )
}

export default OxygenPaymentLinks;